<!--- Formulario VolcarMercancia Unidad Logistica Lectura  ---->
<!---
Descripción del componente y comportamiento:
---------------------------
- Incluye un input que permite buscar por unidad logistica,
partida y código de barras (UCElemtoDeProduccion)
- Una vez establecida la unidad logistica genera un popup para el volcado de mercancia.

Eventos escuchados por el formulario:
-----------------------
-  elementoDeProduccionEstablecido -> abre el popup para el vocado de mercancia.

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page class="pagina">
    <f7-navbar
      :style="appTheme"
      sliding
      no-shadow
    >
      <f7-nav-left name="frmVolcarMercanciaUnidadLogisticaLectura-nav-lefth">
        <f7-link @click="CerrarFrm()">
          <img
            alt="iconBack"
            src="@/static/icons/back.svg"
          >
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>
        {{ $t('production.dump.logisticUnit.reading.title') }}
      </f7-nav-title>

      <!-- botton para finalizacion de partida o lote activo -->
      <div
        v-if="lineaDeProduccion != null"
        class="right btn-navbar-derecha padding-half-left"
      >
        <img
          alt="iconStop"
          src="@/static/icons/ic_stop.svg"
          @click="SolicitudFinalizarVolcado()"
        >
      </div>
    </f7-navbar>
    <div
      class="component-navbar"
    >
      <PCInformacionLineaPunto
        :show-linea-pedido-venta="true"
        :show-salida-produccion="true"
        :salidas-produccion-seleccionadas="salidasProduccion"
        class=" navbar-color"
      />
      <PCInformacionCabecera
        v-if="lineaDeProduccion != null && lineaDeProduccion.GenerarLotesEnVolcado "
        :text="textoLoteActivo"
      />
      <UCCodeScanner
        :allow-manual-code-entry="lecturaCodigoBarrasPorDefecto"
        :autofocus-on-input="lecturaCodigoBarrasPorDefecto"
        :auto-open-camera="!lecturaCodigoBarrasPorDefecto"
        @code-reading="LecturaDeCodigo"
      />
      <UCLectorNFC
        :active="volcadoPorNFCActivo"
        :reversed="volcadoPorNFCTrabajarConIdReversed"
        :show-logo="false"
        @nfc-scan="LecturaDeTagNFC"
      />
    </div>
    <div class="content-list-scroll">
      <div class="div-componenteDeBusqueda">
        <UCProductionElement
          ref="UCProduccionElementDump"
          :restablecer="limpiarLecturaUCElementoDeProduccion"
          :mostrar-titulo="false"
          :autofocus-on-input="lecturaCodigoBarrasPorDefecto"
          :modo-lectura-init="lecturaCodigoBarrasPorDefecto ? 'Codigo' : 'uc'"
          :trabajar-con-numeros-de-serie="Boolean(trabajarConNumerosDeSerie)"
        />
      </div>
      <PCVolcadosLinea
        ref="PCVolcadosLinea"
        :linea-de-produccion="lineaDeProduccion"
        :punto-de-volcado="puntoDeVolcado"
        class="volcados-color"
        @lote-activo="CargarLoteActivo"
        @volcado-seleccionado="VolcadoSeleccionado"
      />
      <!-- <PCVolcadosLineaLotes
        v-if="lineaDeProduccion != null && lineaDeProduccion.GenerarLotesEnVolcado"
        :punto-de-volcado="puntoDeVolcado"
        class="volcados-color"
        @loteActivo="CargarLoteActivo"
        @volcadoSeleccionado="VolcadoSeleccionado"
      /> -->
      <!-- <pre>{{ lineaDeProduccion }}</pre> -->
      <!-- Action Recuperado de elementos volcados sin mercancia -->
      <f7-actions
        id="actions-Recuperado"
        :opened="actionRecuperadoElementoVolcadoAbierto"
        @actions:closed="actionRecuperadoElementoVolcadoAbierto = false"
      >
        <div v-if="actionRecuperadoElementoVolcadoAbierto">
          <f7-actions-group>
            <f7-actions-label class="text-align-center">
              {{ $t('production.dump.logisticUnit.reading.retrieveActions.label') }}
            </f7-actions-label>
            <f7-actions-button
              id="actions-btn-mostrarElementosRecuperables"
              color="green"
              @click="MostrarElementosRecuperables()"
            >
              <span class="display-flex justify-content-center">
                {{ $t('production.dump.logisticUnit.reading.retrieveActions.seeElementsButtonText').toUpperCase() }}
              </span>
            </f7-actions-button>
          </f7-actions-group>

          <f7-actions-group>
            <f7-actions-button color="red">
              <span class="display-flex justify-content-center">
                {{ $t('common.cancel').toUpperCase() }}
              </span>
            </f7-actions-button>
          </f7-actions-group>
        </div>
      </f7-actions>

      <!-- Action Confirmación Finalizar Partidas Activas -->
      <UCConfirmation ref="componenteConfirmacionFinalizarPartidasColaActivas" />
      <UCConfirmation ref="componenteConfirmacionFinalizarLotesColaActivos" />
      <!-- <UCConfirmation
        ref="componenteConfirmacionFinalizarPartidasColaActivas"
        :abierto="actionConfirmarFinalizarPartidasActivas"
        :titulo="FINALIZAR PARTIDAS ACTIVAS"
        :mensaje="Esta acción finalizara las partidas activas del punto de volcado. ¿Deseas continuar con la acción?"
        @Confirmar="actionConfirmarFinalizarPartidasActivas = false; FinalizarPartidasActivasPuntoVolcado()"
        @Cancelar="actionConfirmarFinalizarPartidasActivas = false"
      /> -->

      <f7-popup
        v-model:opened="popupSearchPartidas"
        class="popup-partidas"
      >
        <div class="page">
          <f7-navbar
            :title="$t('production.dump.logisticUnit.reading.finishPopup.title')"
            :style="appTheme"
          >
            <f7-nav-right class="padding-right">
              <f7-link
                popup-close
                icon="icon-close"
              />
            </f7-nav-right>
          </f7-navbar>
          <f7-page-content>
            <div class="container-checkall">
              <label
                class="checkbox margin-right"
              >
                <input
                  :checked="checkAll"
                  type="checkbox"
                  @change="checkAll = !checkAll; ChangeCheckedAll($event.target.checked)"
                >
                <i class="icon-checkbox" />
              </label>
              <span>
                {{ $t('common.selectAll') }}
              </span>
            </div>

            <f7-list
              class="search-list searchbar-found batches-list"
            >
              <f7-list-item
                v-for="part in partidasActivas"
                :key="part.Id"
              >
                <div class="item-inner-row">
                  <div class="item-title">
                    <label
                      class="checkbox margin-right"
                    >
                      <input
                        :checked="part.checked"
                        type="checkbox"
                        @change="ChangeCheckBox(part)"
                      >
                      <i class="icon-checkbox" />
                    </label>
                    <span>{{ `${part.Serie}/${part.Numero}` }}</span>
                  </div>

                  <div
                    v-if="part.Articulo?.Nombre"
                    class="item-subtitle"
                  >
                    <span>{{ part.Articulo.Nombre }}</span>
                  </div>
                </div>
              </f7-list-item>
            </f7-list>

            <div
              class="button-container"
            >
              <div>
                <f7-button
                  class="margin-left"
                  color="gray"
                  fill
                  small
                  :disabled="disabledButton"
                  @click="FinalizarPartidasSeleccionadas()"
                >
                  {{ $t('production.dump.logisticUnit.reading.finishPopup.finishButtonText') }}
                </f7-button>
              </div>
            </div>
            <UCPreload
              :show="mostrarPrecarga"
              :number="1"
            />
          </f7-page-content>
        </div>
      </f7-popup>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import UCProductionElement from '@/components/common/UCProductionElement.vue';
import PCVolcadosLinea from '@/components/production/traceability/PCVolcadosLinea.vue';
import PCInformacionLineaPunto from '@/components/production/traceability/PCInformacionLineaPunto.vue';
import PCInformacionCabecera from '@/components/production/traceability/PCInformacionCabecera.vue';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import UCLectorNFC from '@/components/common/UCLectorNFC.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import UCPreload from '@/components/common/UCPreload.vue';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

/** @import { Partida } from '@erpagroapp/types' */

export default {
  name: 'FrmReadingDumpMerchandiseLogisticUnit',
  components: {
    UCProductionElement,
    PCVolcadosLinea,
    PCInformacionLineaPunto,
    PCInformacionCabecera,
    UCCodeScanner,
    UCConfirmation,
    UCLectorNFC,
    UCPreload,
  },
  props: {
    salidasProduccion: { type: Array, default: () => [] },
  },

  data() {
    return {
      puntoDeVolcado: null,
      lineaDeProduccion: null,
      partida: '', // Contendra la partida en las busquedas por Partida
      limpiarLecturaUCElementoDeProduccion: 1, // Con incrementos limpia las lecturas realizadas.
      actionRecuperadoElementoVolcadoAbierto: false,
      // actionConfirmarFinalizarPartidasActivas: false,
      elementoProduccion: null, // Puede contener una UL o una Partida
      tipoElementoProduccion: null, // Contiene el tipo de objeto de la variable elementoProduccion.
      /** @type {Partida[]} */
      partidasActivas: [],
      mostrarPrecarga: false,
      popupSearchPartidas: false,
      disabledButton: true,
      checkAll: false,
      loteActivo: {
        Id: '',
        Codigo: '',
      }, // Solo se utiliza si la linea de produccion trabaja con asignacion de lotes
      trabajarConNumerosDeSerie: useParamRef('trabajarConNumerosDeSerie'),
      lecturaCodigoBarrasPorDefecto: useSettingRef('Volcado.LecturaCodigoBarrasPorDefecto'),
      volcadoPorNFCActivo: useSettingRef('Volcado.VolcarPorLecturaNFC'),
      volcadoPorNFCTrabajarConIdReversed: useSettingRef('Volcado.VolcarPorLecturaNFCTrabajarConIdInverso'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDeVolcadoSeleccionado',
      'lineaDeProduccionSeleccionada',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'partidaSeleccionada',
      'volcadoSeleccionado',
      'unidadLogisticaSeleccionada',
    ]),

    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
    textoLoteActivo() {
      return this.loteActivo != null
        ? `${this.$t('production.common.currentLot')}: ${this.loteActivo.Codigo}`
        : '';
    },
    headerHeight() {
      const height = document.querySelector('.div-componenteInformacionLineaYPunto')?.offsetHeight ?? 0;
      return `${height}px`;
    },
  },

  async mounted() {
    this.puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
    this.lineaDeProduccion = this.lineaDeProduccionSeleccionada;
    await sleep(50); // tiempo de espera para que se carge los datos de punto de volcado y linea de produccion en el DOM
    this.ActualizarComponenteDeUltimosVolcados();
    this.activarListener();
  },
  beforeUnmount() {
    this.desactivarListener();
  },

  methods: {
    activarListener() {
      Log(this, this.activarListener.name);
      eventBus.on('elementoDeProduccionEstablecido', (data) => {
        this.elementoDeProduccionEstablecido(data);
      });
      eventBus.on('movimientoRealizado', () => {
        this.ActualizarComponenteDeUltimosVolcados();
      });
    },
    desactivarListener() {
      Log(this, this.desactivarListener.name);
      eventBus.off('elementoDeProduccionEstablecido');
      eventBus.off('movimientoRealizado');
    },

    elementoDeProduccionEstablecido(data) {
      Log(this, this.elementoDeProduccionEstablecido.name);
      if (data.Existencias) {
        // Tipo de lectura unidad Logistica
        if (data.Tipo === 'uc' || data.Tipo === null) { // TODO
          // this.unidadLogistica = elementoProduccion;
          // this.partida = null;
          this.unidadLogisticaSeleccionada = data.ElementoProduccion;
          this.partidaSeleccionada = null;
          f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/dump/FrmDumpMerchandiseULView');
        }
        // Tipo de lectura partida
        if (data.Tipo === 'p') {
          // this.partida = elementoProduccion;
          // this.unidadLogistica = null;
          this.unidadLogisticaSeleccionada = null;
          this.partidaSeleccionada = data.ElementoProduccion;
          f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/dump/FrmDumpMerchandiseSplitView');
        }
      } else {
        // Elemento de producción sin existencias.
        this.elementoProduccion = data.ElementoProduccion;
        this.tipoElementoProduccion = data.Tipo;
        this.actionRecuperadoElementoVolcadoAbierto = true;
      }
    },

    limpiarControlUCElementoDeProduccion() {
      Log(this, this.limpiarControlUCElementoDeProduccion.name);
      // NOTA: Limpia el control siempre que detecta un cambio en la variable
      this.limpiarLecturaUCElementoDeProduccion += 1;
    },
    setCheckboxValue() {
      Log(this, this.setCheckboxValue.name);
      this.partidasActivas.forEach((i) => {
        i.checked = false;
      });
    },
    ChangeCheckedAll(value) {
      Log(this, this.ChangeCheckedAll.name);
      this.partidasActivas.forEach((p) => {
        p.checked = value;
      });
      let disabled = true;
      this.partidasActivas.forEach((item) => {
        if (item.checked) {
          disabled = false;
        }
      });
      this.disabledButton = disabled;
    },
    ChangeCheckBox(entity) {
      Log(this, this.ChangeCheckBox.name);
      entity.checked = !entity.checked;
      let disabled = true;
      this.partidasActivas.forEach((item) => {
        if (item.checked) {
          disabled = false;
        }
      });
      this.disabledButton = disabled;
    },
    MostrarElementosRecuperables() {
      Log(this, this.MostrarElementosRecuperables.name);
      if (this.tipoElementoProduccion === 'uc') {
        // this.unidadLogistica = this.elementoProduccion;
        // this.partida = null;
        this.unidadLogisticaSeleccionada = this.elementoProduccion;
        this.partidaSeleccionada = null;
        f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseULView');
      }
      // Tipo de lectura partida
      if (this.tipoElementoProduccion === 'p') {
        // this.partida = this.elementoProduccion;
        // this.unidadLogistica = null;
        this.unidadLogisticaSeleccionada = null;
        this.partidaSeleccionada = this.partida;
        f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseSplitView');
      }
    },
    //* * Método ActualizarComponenteDeUltimosVolcados **/
    ActualizarComponenteDeUltimosVolcados() {
      Log(this, this.ActualizarComponenteDeUltimosVolcados.name);
      this.$refs.PCVolcadosLinea.ActualizarComponenteDeUltimosVolcados();
      // this.$refs.PCVolcadosLote.ActualizarComponenteDeUltimosVolcados();
    },
    //* * Método SolicitudFinalizarPartidasActivasPuntoVolcado **/
    SolicitudFinalizarPartidasActivasPuntoVolcado() {
      Log(this, this.SolicitudFinalizarPartidasActivasPuntoVolcado.name);
      this.$refs.componenteConfirmacionFinalizarPartidasColaActivas.create(
        this.$t('production.dump.logisticUnit.reading.finishPopup.finishBatches.confirmationAlert.title').toUpperCase(),
        this.$t('production.dump.logisticUnit.reading.finishPopup.finishBatches.confirmationAlert.text'),
        () => {
          this.FinalizarPartidasActivasPuntoVolcado();
        },
      );
      this.$refs.componenteConfirmacionFinalizarPartidasColaActivas.show();
    },
    async CargarPartidasActivas() {
      this.checkAll = false;
      this.partidasActivas = [];
      this.mostrarPrecarga = true;
      await this.ObtenerPartidasActivas();
      this.setCheckboxValue();
      this.mostrarPrecarga = false;
    },
    async SolicitudFinalizarVolcado() {
      Log(this, this.SolicitudFinalizarVolcado.name);
      if (!this.lineaDeProduccion.GenerarLotesEnVolcado) {
        // this.SolicitudFinalizarPartidasActivasPuntoVolcado();
        this.popupSearchPartidas = true;
        this.CargarPartidasActivas();
      } else {
        this.SolicitudFinalizarLotesActivosPuntoVolcado();
      }
    },
    //* * Método SolicitudFinalizarLotesActivosPuntoVolcado **/
    SolicitudFinalizarLotesActivosPuntoVolcado() {
      Log(this, this.SolicitudFinalizarLotesActivosPuntoVolcado.name);
      this.$refs.componenteConfirmacionFinalizarLotesColaActivos.create(
        this.$t('production.dump.logisticUnit.reading.finishPopup.finishLots.confirmationAlert.title').toUpperCase(),
        this.$t('production.dump.logisticUnit.reading.finishPopup.finishLots.confirmationAlert.text'),
        () => {
          this.FinalizarLotesActivosPuntoVolcado();
        },
      );
      this.$refs.componenteConfirmacionFinalizarLotesColaActivos.show();
    },
    //* * Método VolcadoSeleccionado **/
    VolcadoSeleccionado(objVolcado) {
      Log(this, this.VolcadoSeleccionado.name);
      this.volcadoSeleccionado = objVolcado;
      this.partidaSeleccionada = { Id: objVolcado.Partida.Id };
      if (objVolcado.IdUnidadLogistica !== 0) {
        this.unidadLogisticaSeleccionada = {
          Id: objVolcado.IdUnidadLogistica,
          NumeroSerie: objVolcado.NumeroSerie,
        };
      }
      f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseSplitView');
    },
    CargarLoteActivo(objLote) {
      Log(this, this.CargarLoteActivo.name);
      this.loteActivo = objLote;
    },
    LecturaDeCodigo(codigo) {
      Log(this, this.LecturaDeCodigo.name);
      this.$refs.UCProduccionElementDump.lecturaDeCodigoDeBarrasRealizada(codigo);
    },
    LecturaDeTagNFC(codigoTag) {
      Log(this, this.LecturaDeTagNFC.name);
      eventBus.emit('lecturaDeCodigoTag', codigoTag);
    },
    //* * Método FinalizarPartidasActivasPuntoVolcado **/
    FinalizarPartidasActivasPuntoVolcado() {
      Log(this, this.FinalizarPartidasActivasPuntoVolcado.name);
      const self = this;
      HiDialog.Preloader(true, this.$t('production.dump.logisticUnit.reading.finishPopup.finishBatches.loading.preloaderText'));
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callFinalizarPartidasActivasPuntoVolcado(self.puntoDeVolcado.Id).then((result) => {
          if (result.Valor) {
            HiDialog.Preloader(false);
            resolve();
          } else {
            HiNotification(this, result.Mensaje);
            HiDialog.Preloader(false);
            reject();
          }
        })
          .catch((error) => {
            HiDialog.Preloader(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
            this.$refs.PCVolcadosLinea.ActualizarComponenteDeUltimosVolcados();
          });
      });
    },
    //* * Método FinalizarLotesActivosPuntoVolcado **/
    FinalizarLotesActivosPuntoVolcado() {
      Log(this, this.FinalizarLotesActivosPuntoVolcado.name);
      const self = this;
      HiDialog.Preloader(true, this.$t('production.dump.logisticUnit.reading.finishPopup.finishLots.loading.preloaderText'));

      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callFinalizarLotesActivosPuntoVolcado(self.puntoDeVolcado.Id).then((result) => {
          if (result.Valor) {
            HiDialog.Preloader(false);
            resolve();
          } else {
            const toastText = result.Mensaje || this.$t('production.dump.logisticUnit.reading.finishPopup.finishLots.loading.errorToastText');
            HiNotification.Toast(toastText);
            HiDialog.Preloader(false);
            reject();
          }
        })
          .catch((error) => {
            HiDialog.Preloader(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
            this.$refs.PCVolcadosLinea.ActualizarComponenteDeUltimosVolcados();
          });
      });
    },
    async ObtenerPartidasActivas() {
      Log(this, this.ObtenerPartidasActivas.name);
      try {
        const result = await callExecuteSPERP(
          'APPERPAGRO_PartidasActivasXPuntoVolcado',
          [
            { NombreParametro: 'idPuntoVolcado', Valor: this.puntoDeVolcado.Id },
          ],
          'PartidaJSON',
        );
        if (result.data.length > 0) {
          this.partidasActivas = result.data;
        }
      } catch (error) {
        LogError(this, this.ObtenerPartidasActivas.name, error);
      }
    },
    async FinalizarPartidasSeleccionadas() {
      Log(this, this.FinalizarPartidasSeleccionadas.name);

      try {
        HiDialog.Preloader(true, this.$t('production.dump.logisticUnit.reading.finishPopup.finishBatchesSelected.loading.preloaderText'));

        const partidasConCheckedTrue = this.partidasActivas.filter((item) => item.checked === true);
        let idsConcatenados = '';
        partidasConCheckedTrue.forEach((partida, indice) => {
          idsConcatenados += partida.Id;
          if (indice < partidasConCheckedTrue.length - 1) {
            idsConcatenados += ',';
          }
        });

        await callExecuteSPERP(
          'APPERPAGRO_FinalizarPartidasActivas',
          [
            { NombreParametro: 'idsPartidas', Valor: idsConcatenados },
          ],
          'PartidaJSON',
        );

        this.CargarPartidasActivas();
      } catch (error) {
        LogError(this, this.FinalizarPartidasSeleccionadas.name, error);
      } finally {
        HiDialog.Preloader(false);
        this.popupSearchPartidas = false;
      }
    },
    //* * Método CerrarFrm **/
    CerrarFrm() {
      Log(this, this.CerrarFrm.name);
      f7.views.main.router.back();
    },
  },
};
</script>

<style scoped lang="scss">
.navbar-color {
  background-color: var(--his-darkgray) !important;
}

.content-list-scroll {
  margin-top: v-bind(headerHeight);
}

.div-componenteInformacionCabecera {
  color: #c0c0c0d6;
  background-color: #ffab00;
  padding-top: 10px;
  text-align: center;
  min-height: 35px;
  position: fixed;
  width: 100%;
  z-index: 1000;
  margin-top: 50px;
}

.div-componenteDeBusqueda {
  padding-top: var(--f7-typography-padding);
  background: var(--his-tierra-white);
  min-height: 50px;
}

.popup-partidas {
  .page {
    .page-content {
      margin-top: -5px;
      padding-bottom: 50px;
    }

    .button-container {
      z-index: 100;
      position: fixed;
      left: 0;
      bottom: 0;
      height: 8%;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      box-shadow: 0 0 5px var(--his-kiwi-pulp);
    }

    .container-checkall {
      height: 35px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      background: #fff;
      margin-bottom: -5px;
      padding-left: 17px;
      padding-top: 10px;
      color: var(--his-slate-blue);
      font-size: 16px;
      font-weight: 600;
    }

    .batches-list {
      .item-inner-row {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;

        .item-subtitle {
          padding-left: 32px;
        }
      }
    }
  }
}

.component-navbar {
  background-color: var(--his-darkgray) !important;
}
</style>
